<template>
  <div>
    <p class="font-weight-bold mb-2">
      {{ tr('common.PASSWORD_REQUIREMENTS') }}
    </p>
    <ul class="list-unstyled ml-2">
      <li>
        <Icon name="checkmark"
              title=""
              class="text-muted"></Icon>
        {{ tr('common.PASSWORD_REQUIREMENTS_CHARACTERS') }}
      </li>
      <li>
        <Icon name="checkmark"
              title=""
              class="text-muted"></Icon>
        {{ tr('common.PASSWORD_REQUIREMENTS_MAX_CHARACTERS') }}
      </li>
      <li>
        <Icon name="checkmark"
              title=""
              class="text-muted"></Icon>
        {{ tr('common.PASSWORD_REQUIREMENTS_NUMBERS') }}
      </li>
    </ul>
    <p class="font-weight-bold mb-0 mt-3">
      {{ tr('common.PASSWORD_REQUIREMENTS_CAVEAT') }}
    </p>
  </div>
</template>

<script>
  import Icon from '../layout/Icon.vue';
  import translator from '~/zf/frontend/common/mixins/translator';

  /*
    [Vue migration] Developer Note
    This component has a twin version for both Vue 2 and Vue 3 projects.
    When making changes, remember to update and test both versions.
  */
  export default {
    name: 'PasswordRequirements',
    compatConfig: {
      MODE: 3,
    },
    components: { Icon },
    mixins: [translator],
  };
</script>
